export class TableContextSegmentMap {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "covered",
            "baseName": "covered",
            "type": "number",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<TableContextSegmentMapRow>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextSegmentMap.attributeTypeMap;
    }
    constructor() {
    }
}
